import { intercept } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Prompt } from 'react-router';
import { Link } from 'react-router-dom';
import { Button, Col, FormGroup, Input, Label, Modal, ModalBody, Row } from 'reactstrap';
import ModalFooter from 'reactstrap/lib/ModalFooter';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import DataTable from 'src/Components/DataTable';
import { IList } from 'src/Components/DataTable/DataTable';
import OpenArrow from 'src/Components/OpenArrow/OpenArrow';
import { IOperator, IRegion } from 'src/Interfaces/WellInterface';
import CsvService from 'src/Services/Csv/CsvService';
import { AdminStore } from 'src/Stores/Admin/AdminStore';
import { MessageStore } from 'src/Stores/Messages/Messages';
import TenantStore from 'src/Stores/Tenant/TenantStore';
import { UserStore } from 'src/Stores/User/UserStore';
import DeepCopy from 'src/UtilityFunctions/DeepCopy';
import { allOrNoneSelected, allOrNoneSelectedInternalProp, selectAllOrNone, selectAllOrNoneInternalProp } from 'src/UtilityFunctions/SelectAllOrNone';
import { GroupEmail, IOperatorRegionExpensePrice, IOperatorRegionPrice } from '../../../../Interfaces/AdminInterface';
import ButtonRow from '../../../ButtonRow';
import { EButton, EInput } from '../../../EInput';



@inject('stores')
@observer
class AdminOperatorDetails extends React.Component {

    public props: any;
    public operator: IOperator = new IOperator();
    public operatorDisposer: any;
    public operatorPriceDisposer: any;
    public operatorExpenseDisposer: any;
    public adminStore: AdminStore;
    public MessageStore: MessageStore;
    private UserStore: UserStore;
    private TenantStore: TenantStore;
    
    private operatorPricesHeader = [
        "Product Name",
        "Primary Category",
        "Taxable",
        "Size",
        "Unit",
        "Specific Gravity",
        "Weight",
        "Cost",
        "Price"
    ];

    private operatorExpenseHeader = [
        "Name",
        "Type",
        "Taxable",
        "Cost",
        "Price",
    ];

    private operatorGroupEmailHeader = [
        "Group Email",
        "Description",
    ];

    private operatorRegionHeaderButtons: any;
    private operatorPriceHeaderButtons: any;
    private operatorExpenseHeaderButtons: any;
    private operatorExportHeaderButtons: any;

    public state = {
        downloadSelected: 'products',
        editingGroupEmail: false,
        groupEmail: new GroupEmail(),
        groupEmailModal: false,
        isDirty: false,
        operator: this.operator,
        operatorExpenseData: { headers: this.operatorExpenseHeader, rows: []} as IList,
        operatorExpensePrices: [] as IOperatorRegionExpensePrice[],
        operatorId: '',
        operatorPrices: [] as IOperatorRegionPrice[],
        operatorRegionData: { headers: this.operatorPricesHeader, rows: []} as IList,
        redirect: false,
        region: new IRegion(),
        regionId: '',
        regions: [] as IRegion[],
        rowIndex: 0,
        selectedEbp: [] as boolean[],
        selectedProducts: [] as boolean[],
        selectedRegions: [] as boolean[],
        showDownloadModal: false,
        showExpenses: false,
        showProducts: false,
        showRegionModal: false,
    };

    constructor(props: any) {
        super(props);

        this.adminStore = this.props.stores.AdminStore;
        this.MessageStore = this.props.stores.MessageStore;
        this.UserStore = this.props.stores.UserStore;
        this.TenantStore = this.props.stores.TenantStore;
        this.initializeHeaders();
    }

    public componentDidMount() {
        this.createDisposers();

        this.adminStore.getRegions()
            .then(regions => {
            this.setState({
                operatorId: this.props.match.params.id,
                regions,
            }, () => {
                if ( this.state.operatorId !== 'new' ) {
                    this.adminStore.getOperator(this.props.match.params.id);
                    // this.adminStore.getOperatorPrices(this.props.match.params.id);
                }
            });
        });
    }

    private initializeHeaders = () => {
        this.operatorPriceHeaderButtons = [
            undefined,
            undefined,
            {
                content: this.renderTaxableHeader('operatorPrices'),
                type: 'render'
            },
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
        ];
    
        this.operatorExpenseHeaderButtons = [
            undefined,
            undefined,
            {
                content: this.renderTaxableHeader('operatorExpensePrices'),
                type: 'render'
            },
            undefined,
            undefined,
        ];

        this.operatorRegionHeaderButtons = [
            {
                content: this.renderRegionSelectHeader,
                type: 'render'
            },
            undefined,
            undefined,
        ];

        this.operatorExportHeaderButtons = [
            {
                content: this.renderExportHeader,
                type: 'render'
            }
        ];
    }


    private renderExportHeader = () => {
        return (
            <div>
                <Button
                color="primary"
                outline={!this.allOrNoneSelectedExport(true)}
                onClick={this.selectAllOrNoneExport(true)}
                >
                    All
                </Button>
                {' '}
                <Button
                    color="primary"
                    outline={!this.allOrNoneSelectedExport(false)}
                    onClick={this.selectAllOrNoneExport(false)}
                >
                    None
                </Button>
            </div>
        );
    }

    private renderRegionSelectHeader = () => {
        return (
        <div>
            <Button
                color="primary"
                outline={!this.allOrNoneSelectedRegions(true)}
                onClick={this.selectAllOrNoneRegions(true)}
            >
                All
            </Button>
            {' '}
            <Button
                color="primary"
                outline={!this.allOrNoneSelectedRegions(false)}
                onClick={this.selectAllOrNoneRegions(false)}
            >
                None
            </Button>
        </div>);
    }

    private renderTaxableHeader = (listName: string) => () => {
        return (
            <div>
                <Button 
                    color="primary"
                    outline={!this.allOrNoneSelectedPrices(true, listName, 'isTaxable')}
                    onClick={this.selectAllOrNonePrices(true, listName, 'isTaxable')}
                >
                    All
                </Button>
                {' '}
                <Button 
                    color="primary"
                    outline={!this.allOrNoneSelectedPrices(false, listName, 'isTaxable')}
                    onClick={this.selectAllOrNonePrices(false, listName, 'isTaxable')}
                >
                    None
                </Button>
            </div>
        );
    }

    public componentWillUnmount() {
        this.clearDisposers();
    }
    public setSelectedRegions = (operator: IOperator) => {
        const selectedRegions = [] as boolean[];
        operator.regions.forEach(region => {
            const index = this.state.regions.findIndex(reg => reg.id === region.id);
            selectedRegions[index] = true;
        });
        return selectedRegions;
    }

    public createDisposers() {
        this.operatorDisposer = intercept(this.adminStore, 'operator', (change: any) => {
            const selectedRegions = this.setSelectedRegions(change.newValue);
            this.setState({
                operator: change.newValue,
                selectedRegions
            });
            
            return change;
        });

        this.operatorPriceDisposer = intercept(this.adminStore, 'operatorProductPrices', (change: any) => {
            this.setState({
                operatorPrices: change.newValue
            }, () => {
                this.formatOperatorPriceData();
            });
            return change;
        });

        this.operatorExpenseDisposer = intercept(this.adminStore, 'operatorExpensePrices', (change: any) => {
            this.setState({
                operatorExpensePrices: change.newValue
            }, () => {
                this.formatOperatorExpenseData();
            });
            return change;
        });
    }

    public clearDisposers() {
        this.operatorDisposer();
        this.operatorPriceDisposer();
        this.operatorExpenseDisposer();
    }

    public handleChange = (event: any) => {
        const operator = this.state.operator;

        operator[event.target.name] = event.target.value;

        this.setState({
            isDirty: true,
            operator
        });
    }

    private toggleRegionModal = () => {
        const operator = this.state.operator;
        const selectedRegions = this.setSelectedRegions(operator);
        this.setState({
            operator,
            selectedRegions,
            showRegionModal: !this.state.showRegionModal,
        });
    }

    private toggleList = (toggleName:string) => () => {
        this.setState({
            [toggleName]: !this.state[toggleName]
        });
    }

    private toggleDownloadModal = (listName?: string) => () => {
        if (!this.state.showDownloadModal) {
            this.setState({
                downloadSelected: listName,
                selectedEbp: new Array(this.state.operatorExpensePrices.length).fill(true),
                selectedProducts: new Array(this.state.operatorPrices.length).fill(true),
                showDownloadModal: true,
            });
        } else {
            this.setState({
                showDownloadModal: !this.state.showDownloadModal
            });
        }
    }

    public handleChangeRegion = (event: any) => {
        const region = this.state.operator.regions.find(or => or.id === event.target.value);
        if (region) {
            this.adminStore.getOperatorPrices(this.state.operator.id, region.id);
            this.adminStore.getOperatorExpenses(this.state.operator.id, region.id);
            this.setState({
                region,
                regionId: region.id,
            });
        } else {
            // this.adminStore.getOperatorPrices(this.state.operator.id);
            this.setState({
                operatorExpensePrices: [],
                operatorPrices: [],
                region: new IRegion(),
                regionId: '',
            }, () => {
                this.formatOperatorPriceData();
                this.formatOperatorExpenseData();
            });
        }
    }

    public handleSavePrices = () => {
        const savePromises = [
            this.adminStore.postOperatorPrices(this.state.operator.id, this.state.operatorPrices, this.state.region.id),
            this.adminStore.postOperatorExpensePrices(this.state.operator.id, this.state.operatorExpensePrices, this.state.region.id),
        ];

        Promise.all(savePromises)
            .then(
            (dataPrice: any) => {
                if(Array.isArray(dataPrice) && dataPrice[0] && dataPrice[1]) {
                    this.MessageStore.addMessage('Changes Have Been Saved', 'success');
                }
            },
            (errorPrice:any) => {
                this.MessageStore.addMessage(
                    errorPrice.toString(),
                    'danger'
                );
            }
        );
    }

    public handleSaveOperator = () => {
        this.adminStore.saveOperator(this.state.operator)
            .then(
                (data: any) => {
                    if(data) {
                        if (this.state.operatorPrices.length > 0) {
                            this.handleSavePrices();
                        } else {
                            const operator = this.state.operator;
                            if (operator.id === '') {
                                operator.id = data;
                            }
                            this.setState({isDirty: false, operator}, () => {
                                this.props.history.push('/admin/operators/' + data);
                                this.MessageStore.addMessage('Changes Have Been Saved', 'success');
                            });
                        }
                    }
                },
                (error: any) => {
                    this.MessageStore.addMessage(
                        error.toString(),
                        'danger'
                    );
                }
            );
    }

    public saveAssignedRegions = () => {
        const selectedRegions = this.state.regions.filter((reg, index) => this.state.selectedRegions[index] === true);
        const operator = this.state.operator;
        operator.regions = selectedRegions;
        this.adminStore.saveOperator(operator)
            .then(currOperator => {
                if(currOperator) {
                    this.MessageStore.addMessage('Operator Saved.', 'success');
                    this.setState({isDirty: false}, () => {
                        if (operator.id === '') {
                            operator.id = currOperator;
                            this.props.history.push('/admin/operators/' + currOperator);
                        }
                    });
                } else {
                    this.MessageStore.addMessage('Operator Not Saved.', 'danger');
                }
                this.setState({showRegionModal: false, operator});
            });
    }

    public removeOperator = () => {
        const areYouSure = confirm(`Deleting the Operator will delete all Prices Lists associated with the Operator.\n\nAre you sure you want to remove operator: ${this.state.operator.operatorName}?\n\nPress OK to delete.`);
        if (areYouSure) {
            this.adminStore.deleteOperator(this.state.operator)
            .then(
                (data: any) => {
                    if(data) {
                        this.setState({isDirty: false}, () => {
                            this.props.history.push('/admin/operators');
                            this.MessageStore.addMessage(
                                'Operator Successfully Deleted',
                                'success'
                            );
                        });
                    }
            });
        }
    }

    private handleDateChange = (event: any) => {
        const operator = this.state.operator;
        operator[event.target.name] = event.target.value;
        this.setState({
            isDirty: true,
            operator
        });
    }

    private handlePriceChange = (listName: string, index: number) => (event:any) => {
        const operatorPrices = this.state[listName];
        operatorPrices[index].price = event.target.value;
        this.setState({[listName]: operatorPrices});
    }

    private handleCostChange = (listName: string, index: number) => (event:any) => {
        const operatorPrices = this.state[listName];
        operatorPrices[index].cost = event.target.value;
        this.setState({[listName]: operatorPrices});
    }

    private handleTaxableClick = (listName: string, index: number) => (event: any) => {
        const operatorPrices = this.state[listName];
        operatorPrices[index].isTaxable = !operatorPrices[index].isTaxable;
        this.setState({[listName]: operatorPrices});
    }

    private allOrNoneSelectedExport = (isAll: boolean) => {
        switch (this.state.downloadSelected) {
            case 'products':
                return allOrNoneSelected(isAll, 'operatorPrices', 'selectedProducts', this.state);
                break;
            case 'expenses':
                    return allOrNoneSelected(isAll, 'operatorExpensePrices', 'selectedEbp', this.state);
            default:
                break;
        }
    }

    private selectAllOrNoneExport = (isAll: boolean) => () => {
        switch (this.state.downloadSelected) {
            case 'products':
                const selectedProducts = selectAllOrNone(isAll, this.state.operatorPrices);
                this.setState({
                    selectedProducts
                });
                break;
            case 'expenses':
                const selectedEbp = selectAllOrNone(isAll, this.state.operatorExpensePrices);
                this.setState({
                    selectedEbp
                });
            default:
                break;
        }
    }

    private allOrNoneSelectedRegions = (isAll: boolean) => {
        return allOrNoneSelected(isAll, 'regions', 'selectedRegions', this.state);
    }

    private selectAllOrNoneRegions = (isAll: boolean) => () => {
        const selectedRegions = selectAllOrNone(isAll, this.state.regions);
        this.setState({
            selectedRegions,
        });
    }
    private allOrNoneSelectedPrices = (isAll: boolean, listName: string, propName: string) => {
        const elements: any[] = this.state[listName];
        return allOrNoneSelectedInternalProp(isAll, elements, propName);
    }

    private selectAllOrNonePrices = (value: boolean, listName: string, propName: string) => () => {
        const elements: any[] = this.state[listName];
        selectAllOrNoneInternalProp(value, elements, propName);
        this.setState({[listName]: elements});
    }

    private renderPriceInput = (regionPrice: IOperatorRegionPrice, index:number) => () => {
        return (
            <Input
                type="text"
                name={`regionPrice-${regionPrice.id}`}
                id={`regionPrice-${regionPrice.id}`}
                value={regionPrice.price}
                onChange={this.handlePriceChange('operatorPrices', index)}
            />
        );
    }

    private renderExpensePriceInput = (expensePrice: IOperatorRegionExpensePrice, index:number) => () => {
        return (
            <Input
                type="text"
                name={`regionExpensePrice-${expensePrice.id}`}
                id={`regionExpensePrice-${expensePrice.id}`}
                value={expensePrice.price}
                onChange={this.handlePriceChange('operatorExpensePrices', index)}
            />
        );
    }


    private renderCostInput = (regionPrice: IOperatorRegionPrice, index:number) => () => {
        return (
            <Input
                type="text"
                name={`regionCost-${regionPrice.id}`}
                id={`regionCost-${regionPrice.id}`}
                value={regionPrice.cost}
                onChange={this.handleCostChange('operatorPrices', index)}
            />
        );
    }

    private renderExpenseCostInput = (expensePrice: IOperatorRegionExpensePrice, index:number) => () => {
        return (
            <Input
                type="text"
                name={`regionExpenseCost-${expensePrice.id}`}
                id={`regionExpenseCost-${expensePrice.id}`}
                value={expensePrice.cost}
                onChange={this.handleCostChange('operatorExpensePrices', index)}
            />
        );
    }

    private renderTaxableCheckbox = (listName: string, regionPrice: IOperatorRegionPrice | IOperatorRegionExpensePrice, index: number) => () => {
        return (
            <div className="multi-select-row">
                <Input onChange={this.handleTaxableClick(listName, index)} checked={regionPrice.isTaxable} type="checkbox" value="" />
            </div>
        );
    }
    private formatOperatorPriceData = () => {
        const operatorPrice = this.state.operatorPrices;
        const rows:any = [];

        operatorPrice.forEach((regionPrice, index) => {
            const tempRow = [
                {
                    content: regionPrice.name
                },
                {
                    content: regionPrice.category,
                },
                {
                    content: this.renderTaxableCheckbox('operatorPrices', regionPrice, index),
                    sortItem: regionPrice.isTaxable,
                    type: 'render',
                },
                {
                    content: regionPrice.size
                },
                {
                    content: regionPrice.unit
                },
                {
                    content: regionPrice.specificGravity,
                },
                {
                    content: regionPrice.weight,
                },
                {
                    content: this.renderCostInput(regionPrice, index),
                    sortItem: regionPrice.cost,
                    type: 'render',
                },
                {
                    content: this.renderPriceInput(regionPrice, index),
                    sortItem: regionPrice.price,
                    type: 'render'
                }
            ];

            rows.push(tempRow);
        });

        this.setState({operatorRegionData: { headers: this.operatorPricesHeader, rows}});
    }

    private formatOperatorExpenseData = () => {
        const operatorExpenses = this.state.operatorExpensePrices;
        let rows = [];
        if (this.state.operatorExpenseData && this.state.operatorExpenseData.rows) {
            rows = this.state.operatorExpenseData.rows;
            rows.splice(0);
        }

        operatorExpenses.forEach((operatorRegionExpensePrice, index) => {
            const tempRow = [
                {
                    content: operatorRegionExpensePrice.name
                },
                {
                    content: operatorRegionExpensePrice.isRental ? "Rental" : "Service"
                },
                {
                    content: this.renderTaxableCheckbox('operatorExpensePrices', operatorRegionExpensePrice, index),
                    sortItem: operatorRegionExpensePrice.isTaxable,
                    type: 'render',
                },
                {
                    content: this.renderExpenseCostInput(operatorRegionExpensePrice, index),
                    sortItem: operatorRegionExpensePrice.cost,
                    type: 'render'
                },
                {
                    content: this.renderExpensePriceInput(operatorRegionExpensePrice, index),
                    sortItem: operatorRegionExpensePrice.price,
                    type: 'render'
                },
            ];

            rows.push(tempRow);
        });

        this.setState({operatorExpenseData: {headers: this.operatorExpenseHeader, rows}});
    }

    private formatOperatorGroupEmailsData = () => {
        const operatorGroupEmails = this.state.operator.groupEmails;
        const rows = [] as any[];
        operatorGroupEmails.forEach(groupEmail => {
            const tempRow = [
                {
                    content: groupEmail.email
                },
                {
                    content: groupEmail.description,
                }
            ];
            rows.push(tempRow);
        });
        return { headers: this.operatorGroupEmailHeader, rows };
    }

    private addOperatorGroupEmail = (addAnother: boolean) => () => {
        const { groupEmail, operator, rowIndex, editingGroupEmail } = this.state;
        if (editingGroupEmail) {
            operator.groupEmails[rowIndex] = groupEmail;
        } else {
            operator.groupEmails.push(groupEmail);
        }
        if (addAnother) {
            this.setState({groupEmail: new GroupEmail(), operator});
        } else {
            this.setState({editingGroupEmail: false, groupEmail: new GroupEmail(), groupEmailModal: false, operator});
        }
    }

    private onEditGroupEmail = (index: number) => {
        this.setState({editingGroupEmail: true, groupEmail: DeepCopy(this.state.operator.groupEmails[index]), groupEmailModal: true, rowIndex: index});
    }

    private toggleGroupEmail = () => {
        this.setState({groupEmailModal: !this.state.groupEmailModal});
    }

    private onDeleteGroupEmail = (index: number) => {
        const operator = this.state.operator;
        const groupEmail = operator.groupEmails;
        groupEmail.splice(index, 1);
        this.setState({operator});
    }

    private handleGroupEmailChange = (event: any) => {
        const groupEmail = this.state.groupEmail;
        groupEmail[event.target.name] = event.target.value;
        this.setState({groupEmail});
    }
    
    public handleRegionSelect = (index: number) => (event: any) => {
        const selectedRegions = this.state.selectedRegions;
        selectedRegions[index] = !selectedRegions[index];
        this.setState({selectedRegions});
    }

    public renderRegionCheckBox = (index: number) => () => {
        const checked = this.state.selectedRegions;
        return (
            <div className="multi-select-row">
                <Input
                    type="checkbox"
                    checked={checked[index]}
                    onChange={this.handleRegionSelect(index)}
                />
            </div>
        );
    }
    public formatRegionSelectionData = () => {
        const headers = [
            '',
            'Region Name',
            'State',
        ];

        const rows: any = [];

        this.state.regions.forEach((region, index) => {
            const tempRow = [
                {
                    content: this.renderRegionCheckBox(index),
                    type: 'render'
                },
                {
                    content: region.name,
                },
                {
                    content: region.state,
                }
            ];

            rows.push(tempRow);
        });

        return { headers, rows };
    }


    private exportSelectedProducts = () => {
        const selectedProducts = [] as IOperatorRegionPrice[];
        const operatorProducts = this.state.operatorPrices;
        operatorProducts.forEach((operatorProduct, index) => {
            if(this.state.selectedProducts[index]) {
                selectedProducts.push(operatorProduct);
            }
        });
        const selectedEbp = [] as IOperatorRegionExpensePrice[];
        const operatorExpenses = this.state.operatorExpensePrices;
        operatorExpenses.forEach((operatorExpense, index) => {
            if(this.state.selectedEbp[index]) {
                selectedEbp.push(operatorExpense);
            }
        });
        CsvService.exportOperatorPriceList(this.state.operator.operatorName, this.state.region.name, selectedProducts, selectedEbp);
        this.setState({
            showDownloadModal: false,
        });
    }
    
    private handleProductSelect = (index:number) => (event: any) => {
        switch (this.state.downloadSelected) {
            case 'products':
                const selectedProducts = this.state.selectedProducts;
                selectedProducts[index] = !selectedProducts[index];
                this.setState({selectedProducts});
                break;
            case 'expenses':
                const selectedEbp = this.state.selectedEbp;
                selectedEbp[index] = !selectedEbp[index];
                this.setState({selectedEbp});
                break;
            default:
                break;
        }
    }


    private renderSelectProductCheckBox = (index: number) => () => {
        let checked: boolean[];
        switch (this.state.downloadSelected) {
            case 'products':
                checked = this.state.selectedProducts;
                break;
            case 'expenses':
                checked = this.state.selectedEbp;
                break;
            default:
                checked = [];
                break;
        }
        return (
            <div className="multi-select-row">
            <Input
                type="checkbox"
                checked={checked[index]}
                onChange={this.handleProductSelect(index)}
            />
        </div>
        );
    }

    public formatExportSelection = (type: string) => {
        if(type === 'products') {
            return this.formatProductExportSelection();
        } else if (type === 'expenses') {
            return this.formatEbpExportSelection();
        } else {
            return undefined as unknown as IList;
        }
    }

    public toggleDownloadList = () => {
        if (this.state.downloadSelected === 'products') {
            this.setState({
                downloadSelected: 'expenses',
            });
        } else {
            this.setState({
                downloadSelected: 'products',
            });
        }
    }


    public formatEbpExportSelection = () => {
        const headers = [
            '',
            'Name',
            'Type',
            'Taxable',
            'Cost',
            'Price',
        ];

        const rows: any[] = [];

        this.state.operatorExpensePrices.forEach((operatorExpense, index) => {
            const tempRow = [
                {
                    content: this.renderSelectProductCheckBox(index),
                    type: 'render',
                },
                {
                    content: operatorExpense.name
                },
                {
                    content: operatorExpense.isRental ? 'Rental' : 'Service',
                },
                {
                    content: operatorExpense.isTaxable ? 'Yes' : 'No',
                },
                {
                    content: operatorExpense.cost,
                },
                {
                    content: operatorExpense.price,
                }
            ];
            rows.push(tempRow);
        });

        return {headers, rows};
    }

    public formatProductExportSelection = () => {
        const headers = [
            '',
            "Product Name",
            "Primary Category",
            "Taxable",
            "Size",
            "Unit",
            "Specific Gravity",
            "Weight",
            "Cost",
            "Price"
        ];

        const rows: any = [];

        this.state.operatorPrices.forEach((operatorPrice, index) => {
            const tempRow = [
                {
                    content: this.renderSelectProductCheckBox(index),
                    type: 'render',
                },
                {
                    content: operatorPrice.name
                },
                {
                    content: operatorPrice.category
                },
                {
                    content: operatorPrice.isTaxable ? 'Yes' : 'No'
                },
                {
                    content: operatorPrice.size
                },
                {
                    content: operatorPrice.unit
                },
                {
                    content: operatorPrice.specificGravity
                },
                {
                    content: operatorPrice.weight
                },
                {
                    content: operatorPrice.cost
                },
                {
                    content: operatorPrice.price
                },
            ];
            rows.push(tempRow);
        });

        return { headers, rows };
    }

    public render() {
        return(
            <div>
                <Prompt when={this.state.isDirty} message={"Changes have been made.\n\nPress Cancel then Press Save OR Press OK to continue without saving."} />
                <Row>
                    <Col md="6">
                        <FormGroup className="required">
                            <Label>Name</Label>
                            <EInput
                                type="text"
                                name="operatorName"
                                required={true}
                                value={this.state.operator.operatorName}
                                onChange={this.handleChange}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Customer ERP Id</Label>
                            <EInput
                                type="text"
                                name="erpId"
                                value={this.state.operator.erpId}
                                onChange={this.handleChange}
                            />
                        </FormGroup>
                        <Button style={{marginTop: '5px', marginBottom: '5px'}} color="primary" block={true} onClick={this.toggleRegionModal} disabled={this.state.operator.operatorName === ''}>Assign Operator to Regions</Button> 
                        <FormGroup>
                            <Label>Select Region to View/Edit Operator Prices</Label>
                            <Input
                                type="select"
                                name="regionName"
                                required={true}
                                value={this.state.region.id}
                                onChange={this.handleChangeRegion}
                                >
                            <option />
                            { this.state.operator.id !== '' && this.state.operator.regions.map((or, index) => 
                                <option key={or.id !== '' ? or.id : index} value={or.id}>{ or.name }</option>
                                )}
                            </Input>
                        </FormGroup>
                        <FormGroup>
                            <Label>Effective Date</Label>
                            <EInput
                                type="date"
                                name="effectiveDate"
                                id="effectiveDate"
                                value={this.state.operator.effectiveDate}
                                onChange={this.handleDateChange}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="6">
                        {/* <FormGroup>
                            <Label>Group Email</Label>
                            <EInput
                                type="text"
                                name="groupEmail"
                                data-validation="email"
                                value={this.state.operator.groupEmail}
                                onChange={this.handleChange}
                                />
                        </FormGroup> */}
                        <DataTable
                            list={this.formatOperatorGroupEmailsData()}
                            onEdit={this.onEditGroupEmail}
                            onNew={{
                                callback: this.toggleGroupEmail,
                                text: 'Add New Group Email'
                            }}
                            onDelete={this.onDeleteGroupEmail}
                        />
                    </Col>
                </Row>
                {
                    this.state.operatorPrices.length > 0 &&
                    <React.Fragment>
                        <Row>
                            <Col>
                                <h4 onClick={this.toggleList('showProducts')}><OpenArrow color={this.TenantStore.iconColor} open={this.state.showProducts} />Operator Product List</h4>
                            </Col>
                        </Row>
                        {
                            this.state.showProducts &&
                            <Row>
                                <Col>
                                    <DataTable
                                        list={this.state.operatorRegionData}
                                        headerButtons={this.operatorPriceHeaderButtons}
                                        maxHeight='50vh'
                                    />
                                </Col>
                            </Row>
                        }
                    </React.Fragment>
                }
                {
                    this.state.operatorExpensePrices.length > 0 &&
                    <React.Fragment>
                        <Row>
                            <Col>
                                <h4 onClick={this.toggleList('showExpenses')}><OpenArrow color={this.TenantStore.iconColor} open={this.state.showExpenses} />Operator EBP List</h4>
                            </Col>
                        </Row>
                        {
                            this.state.showExpenses &&
                            <Row>
                                <Col>
                                <DataTable
                                    list={this.state.operatorExpenseData}
                                    headerButtons={this.operatorExpenseHeaderButtons}
                                    maxHeight='50vh'
                                />
                                </Col>
                            </Row>
                        }
                    </React.Fragment>
                }
                    
                <ButtonRow>
                    {
                        this.UserStore.hasPermission('Permissions.Admin.Operators.Delete') &&
                        <Button color="danger" onClick={this.removeOperator}>Delete Operator</Button>
                    }
                    {
                        this.state.operatorPrices.length > 0 &&
                        <Button className="secondary" onClick={this.toggleDownloadModal('products')}>Download Price List</Button>
                    }
                    {
                        this.state.operator.id !== '' && this.state.regionId !== '' && 
                        <Link style={{marginRight: '10px' }} className="secondary btn btn-secondary" target="_blank" to={`/print/operator/${this.state.operator.id}/region/${this.state.regionId}/pricelist`} >
                            Print Price List
                        </Link>
                    }
                    {/* No Separate Download for Expenses {
                        this.state.operatorExpensePrices.length > 0 &&
                        <Button className="secondary" onClick={this.toggleDownloadModal('expenses')}>Download EBP List</Button>
                    } */}
                    {
                        (this.state.operator.id === '' ?
                        this.UserStore.hasPermission('Permissions.Admin.Operators.Create')
                        :
                        this.UserStore.hasPermission('Permissions.Admin.Operators.Update'))
                        &&
                        <EButton color="primary" onClick={this.handleSaveOperator}>Save Operator</EButton>
                    }
                </ButtonRow>
                <Modal size="xl" isOpen={this.state.showDownloadModal} toggle={this.toggleDownloadModal()}>
                    <ModalHeader toggle={this.toggleDownloadModal()}>
                        Download Price List
                    </ModalHeader>
                    <ModalBody>
                        <Button color="primary" onClick={this.toggleDownloadList}>{this.state.downloadSelected === 'products' ? 'Show EBP List' : 'Show Product List'}</Button>
                        <DataTable
                            headerButtons={this.operatorExportHeaderButtons}
                            list={this.formatExportSelection(this.state.downloadSelected)}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button className="secondary" onClick={this.toggleDownloadModal()}>Cancel</Button>
                        <Button color="primary" onClick={this.exportSelectedProducts}>Download File</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.showRegionModal} toggle={this.toggleRegionModal}>
                    <ModalHeader toggle={this.toggleRegionModal}>
                        Assign Operator to Regions
                    </ModalHeader>
                    <ModalBody>
                        <DataTable
                            headerButtons={this.operatorRegionHeaderButtons}
                            list={this.formatRegionSelectionData()}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button className="secondary" onClick={this.toggleRegionModal}>Cancel</Button>
                        <Button color="primary" onClick={this.saveAssignedRegions}>Save Assigned Regions</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.groupEmailModal} toggle={this.toggleGroupEmail}>
                    <ModalHeader toggle={this.toggleGroupEmail}>
                        Add/Edit Group Email
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <Label>Email</Label>
                                <EInput
                                    name="email"
                                    id="email"
                                    value={this.state.groupEmail.email}
                                    onChange={this.handleGroupEmailChange}
                                    data-validation="email"
                                    required={true}
                                />
                                <Label>Description</Label>
                                <EInput
                                    name="description"
                                    id="description"
                                    value={this.state.groupEmail.description}
                                    onChange={this.handleGroupEmailChange}
                                />
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="secondary" onClick={this.toggleGroupEmail}>Cancel</Button>
                        <EButton color="primary" onClick={this.addOperatorGroupEmail(false)}>Save</EButton>
                        <EButton color="primary" onClick={this.addOperatorGroupEmail(true)}>Add Another</EButton>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default AdminOperatorDetails;


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/Operators/AdminOperatorDetails.tsx